import {
    AccountingRoleIcon,
    AdminRoleIcon,
    ExtranetIcon,
    ImportRoleIcon,
    SalesRoleIcon,
    ShopAdminRoleIcon,
    ShoppingCartIcon,
    SuluAdminRoleIcon,
    SuperAdminRoleIcon,
    SynergyApiRoleIcon,
    SynergySupplierAdminRoleIcon,
} from '@synergy/theme';
import { FunctionComponent } from 'react';
import { PoolTypography } from '@synergy/components';
import { SvgIconProps } from '@mui/material';
import { UserRole } from '@synergy/models';

import { OptionCard, OptionCardProps } from '../../../../../../common/components/option-card/option-card';

export interface ContactDetailPermissionsRoleCardProps extends OptionCardProps {
    role: UserRole;
}

export const ContactDetailPermissionsRoleCard = (props: ContactDetailPermissionsRoleCardProps) => {
    const { role, ...optionCardProps } = props;

    const iconMap: Record<string, FunctionComponent<SvgIconProps>> = {
        [UserRole.Admin]: AdminRoleIcon,
        [UserRole.SuperAdmin]: SuperAdminRoleIcon,
        [UserRole.Extranet]: ExtranetIcon,
        [UserRole.ShopUser]: ShoppingCartIcon,
        [UserRole.ShopAdmin]: ShopAdminRoleIcon,
        [UserRole.Sales]: SalesRoleIcon,
        [UserRole.Accounting]: AccountingRoleIcon,
        [UserRole.Configuration]: ImportRoleIcon,
        [UserRole.ImportApi]: SynergyApiRoleIcon,
        [UserRole.SuluAdmin]: SuluAdminRoleIcon,
        [UserRole.SupplierAdmin]: SynergySupplierAdminRoleIcon,
    };

    const icon = iconMap[role];

    return (
        <OptionCard {...optionCardProps} icon={icon({})}>
            <PoolTypography typography="body1" id={`app.role.${role}`} />
        </OptionCard>
    );
};
